import React, { Component } from "react";

import DataTable from 'react-data-table-component';
import $ from "jquery";


const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true
};
export default class Prestamo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaPrestamo: [],
    };
  }

  componentDidMount() {

  }



  getColumn() {
    return [
      {
        name: "Crédito",
        selector: row => row.credito,
        width: "180px",
      },
      {
        name: "Tipo",
        selector: row => row.tipo
      },
      {
        name: "Monto",
        selector: row => row.monto,
        width: "150px",
        right: true
      },
      {
        cell: (row) => (
          <input
            ref={() => this.grupoSel}
            id={"radio_" + row.id}
            type="radio"
            key={row.id}
            type="radio"
            name="rowRadio"
            value={row.id}
            onClick={this.selGrupoEvt}
          ></input>
        ),
        width: "50px",
      },
    ];
  }

  selGrupoEvt = (e) => {

    this.preSele = e.currentTarget;
    /*console.log("selecciona "+e.currentTarget)*/
    //console.log("el valor de rueda " + this.preSele.id)

    for (var i = 0; i < this.props.prestamos.length; i++) {
      var pre = this.props.prestamos[i]
      var pre_id = "radio_" + pre.id;
      if (pre_id === this.preSele.id) {
        this.props.datoPrestamo(pre.credito, pre.tipo, pre.monto);

      }
    }
    this.enableNext();
  };
  enableNext() {


    this.checkGrilla();

  }

  checkGrilla() {
   // console.log("en check " + this.preSele)
    if (this.preSele !== undefined) {
      $("#" + this.preSele.id).prop("checked", true);
    }

  }


  seleccionarFila(row) {

    this.preSele = document.getElementById("radio_" + row.id)
    this.props.datoPrestamo(row.credito, row.tipo, row.monto);
   

  }

  obtenerPrestamos() {
    if (this.props.prestamos !== undefined && this.props.prestamos.length === 0)
    return (
      <div>
        <span />
      </div>
    )
    return (
      <div>
        <div className="row ">
          <div className="col-md-12">
            <label className="input-label-bold">
              Seleccione el Crédito *
                </label>
            <div className="table-responsive">
              <DataTable
                noHeader={true}
                pagination={true}
                columns={this.getColumn()}
                data={this.props.prestamos}
                dense={true}
                pagination={true}
                paginationComponentOptions={paginationOptions}
                noDataComponent="no hay registros para mostrar"
                responsive={true}
                striped={true}
                pointerOnHover
                onRowClicked={(e) => this.seleccionarFila(e)} />
            </div>
          </div>
        </div>
      </div>
    )
  }


  render() {
    return (
      <div>
        <hr />
        <div className="form-group">
          {this.obtenerPrestamos()}
        </div>
      </div>
    );
  }
}
